exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contributor-badge-cw[data-v-365612b6]::before {\n  top: -18px;\n  left: -18px;\n  right: -18px;\n  bottom: -18px;\n  border-radius: 200px;\n  border: 5px solid transparent;\n}\n.hotshot[data-v-365612b6] {\n  background: -webkit-linear-gradient(45deg, var(--cw-700), var(--cw-alt));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n}\n", ""]);

// exports
